import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagLK = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FF9811",
  d: "M19.565 4.348H10.91c-.383.262-.759.535-1.126.818L7.609 25l2.174 19.834c.367.283.743.556 1.126.818h8.656V4.348Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M0 25c0 8.08 3.835 15.264 9.783 19.835V5.165C3.835 9.736 0 16.92 0 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M40.217 15.24v.626l.023.004-.023-.63Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M48.007 31.522h-4.71l-1.993 2.174v4.348h-4.348V35.87h2.174v-4.348h-9.783v2.717h-2.174V29.06a3.253 3.253 0 0 1-1.086-2.43V12.5c0-1.8 1.46-3.26 3.26-3.26v20.108h4.348l1.492-1.243a5.2 5.2 0 0 1-.405-2.018v-3.26h-3.26v-6.522h6.521c0-1.087 1.63-2.174 1.63-2.174s1.63 1.087 1.63 2.174v6.521c1.21.015 3.132-.017 5.207 0a6.595 6.595 0 0 1-.858-3.26c0-1.918.828-3.643 2.146-4.836A25.11 25.11 0 0 0 39.09 4.348H22.826v41.304H39.09a25.055 25.055 0 0 0 9.777-13.192l-.86-.938Z"
}));
FlagLK.displayName = 'FlagLK';
export default withFlagWrapper(FlagLK);
//# sourceMappingURL=index.js.map